import { render, staticRenderFns } from "./StructureViewer.vue?vue&type=template&id=28be7b5d&scoped=true"
import script from "./StructureViewer.vue?vue&type=script&lang=js"
export * from "./StructureViewer.vue?vue&type=script&lang=js"
import style0 from "./StructureViewer.vue?vue&type=style&index=0&id=28be7b5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be7b5d",
  null
  
)

export default component.exports